module.exports = __webpack_public_path__ + "static/img/basic-book-img.f5d9b7e0.png";